import React from "react";
import Video from "../videos/vegetables.mp4"

import "../styles/pages/quisines.scss";
import "../styles/components/hero/hero.scss";
import "../styles/components/buttons/btn-white-o.scss";
//import BannerVideo from "../components/BannerVideo";
import Banner from "../components/Banner";
import Hero from "../components/Hero";

import { QUISINES } from "../constants/constants";
import AppleDownload from "../icons/appledownload.svg";
import googleplaydownload from "../icons/googleplaydownload.png";


export default function Quisinespage() {
    return (

        <Hero hero="cf-bg--quisines" text="center">
            
            <Banner title={QUISINES.title}
                subtitle={QUISINES.subtitles}
                />

                <a className="cf-hero__link"
                    href={QUISINES.note.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    >{QUISINES.note.text}</a>
                <div className="cf-hero__btn-group">
                    {QUISINES.buttons.map((item, index) => {
                        return (
                            <a href={item.link}
                                key={index}
                                target='_blank'
                                rel="noopener noreferrer"
                                aria-label={`To open ${item.ariaLabel}`}
                                className="icon"
                                id="quisines-btn"
                                >
                                {/*<span>{item.text}</span> when you want to enable text */}
                                <span> <img src={item.ico === "appledownload" && AppleDownload} style={{height: 71 + "px"}}></img> </span>
                                <span> <img src={item.ico === "androiddownload" && googleplaydownload} style={{height: 100 + "px"}}></img> </span>
                            </a>
                        )
                    })}
                </div>
        </Hero>
    )


    /*
    return (
        <header className="header">
            <video className='video-background' autoPlay loop muted>
                    <source src={Video} type='video/mp4' />
            </video>
          <div className="cf-hero__info">
          </div>
        </header>
      );
/*
    /*
    return (
        <div>
            <section class="header">
                <video className='video-background' autoPlay loop muted>
                    <source src={Video} type='video/mp4' />
                </video>
                <div class="welcome">
                    <h1>Explore Texas</h1>
                    <a href="#" class="btn btn-howdy">Howdy</a>
                    <a href="#" class="btn btn-events">Events</a>
                </div>
            </section>
        </div>
    )
    */
}
